import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { CityService } from 'src/app/shared/API-Service/services/city.service';
import { CountryService } from 'src/app/shared/API-Service/services/country.service';

@Component({
  selector: 'app-insert-country',
  templateUrl: './insert-country.component.html',
  styleUrls: ['./insert-country.component.css']
})
export class InsertCountryComponent implements OnInit {
  recordtoupdate: any;
  Donationcategory;
  Donationmaintype;
  countryForm : FormGroup;
  update:boolean = false;
  button:boolean = false;
  constructor(private _CountryService:CountryService, private _Router:Router, private _FormBuilder:FormBuilder,
            ) { }

  ngOnInit(): void {
    this.initiate();
    this.checkEdit();
  }
  initiate(){
    this.countryForm = this._FormBuilder.group({
      TitleAr: ['', Validators.required],
      Title:['']
    });
  }
  get fc() {
    return this.countryForm.controls;
  }




  checkEdit() {
    this._CountryService.Data.subscribe((res) => {
      if (res != null) {
        this.countryForm = this._FormBuilder.group({
          TitleAr: [res.titleAr, Validators.required],
          Title:[res.title]
        });
        this.update = true;
        this.recordtoupdate = res ;
      
      } else {
        // this.initiate();
      }
     
    });
  }

  onSubmit(){
    this.button = true;
   if(this.update == false && this.countryForm.status == "VALID"){
  
    this._CountryService.CreateCountry(this.countryForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "Submitted Successfuly",
        showConfirmButton: false,
        timer: 1500,
      });
      this.countryForm.reset();
      this._Router.navigate(['/content/admin/ViewCountry']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text:err.error.message    
      }) 
      this.button = false ;
    }, () => {
    })
   } else if(this.countryForm.status == "VALID"){
    this.countryForm.addControl('id', new FormControl(this.recordtoupdate.id, Validators.required));
    this._CountryService.UpdateCountry(this.countryForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "updated Successfuly",
        showConfirmButton: false,
        timer: 1500,
      });
      this.countryForm.reset();
      this._Router.navigate(['/content/admin/ViewCountry']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text:err.error.message    
      }) 
    }, () => {
    })
   }else {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text:"Please check that all the fields are written"   
    })
    this.countryForm.markAllAsTouched();
    this.button = false;
   }
  }


  ngOnDestroy(){
    this._CountryService.Data.next(null);
     }
}
